// extracted by mini-css-extract-plugin
export default {"actions":"FormPopupFooter_actions__nkGG7","cancelBtn":"FormPopupFooter_cancelBtn__3am0K","saveBtn":"FormPopupFooter_saveBtn__fyWm2"};